<template>
  <data-section
    style="font-size: 15px"
    theme="blue"
    title="其他人壽保單"
    :isLoading="isLoading"
    :datas="datas"
    :_fields="
      [
        {
          name: '公司/保單號碼\n險種',
          key: 'productname',
          width: 274,
          sortable: true,
          orderByMultiKey: ['sortProductname'],
          orderByMultiType: ['asc']
        },
        {
          name: '要保人',
          key: 'applicant',
          width: 79,
          sortable: true,
          orderByMultiKey: ['sortApplicant'],
          orderByMultiType: ['asc']
        },
        {
          name: '被保人',
          key: 'insuredpersonname',
          width: 79,
          sortable: true,
          orderByMultiKey: ['sortInsuredpersonname'],
          orderByMultiType: ['asc']
        },
        { name: '繳費\n年期', key: 'year', width: 55 },
        {
          name: '承保\n對象',
          key: 'relation',
          width: 49,
          thClassName: 'text-left',
          className: 'text-left'
        },
        {
          name: '投保始期',
          key: 'insurancedate',
          width: 95,
          className: 'text-left',
          sortable: true,
          orderByMultiKey: ['sortInsuranceADDate'],
          orderByMultiType: ['asc']
        },
        {
          name: '保額',
          key: 'amountofinsurance',
          width: 96,
          thClassName: 'text-right',
          className: 'text-right',
         /* sortable: true,
          orderByMultiKey: ['amountofinsurance'],
          orderByMultiType: ['asc'] */
        },
        {
          name: '保費/繳別',
          key: 'bknm',
          width: 138,
          thClassName: 'text-right',
          className: 'text-right',
          sortable: true,
          orderByMultiKey: [
            'sortBknm',
            'isprimarycontract',
            'money',
            'longPremium'
          ],
          orderByMultiType: ['asc', 'adesc', 'asc', 'asc']
        },
        { name: '受益人', key: 'bnf', width: 99 }
      ].concat(_fields)
    "
    @toggle="
      (isShow) => $router.assignQuery({ OtherLifeInsuranceShow: isShow })
    "
    :initShow="$route.query['OtherLifeInsuranceShow'] !== 'false'"
  >
    <template scope="props"  v-if="refresh">
      <data-table
        v-bind="
          Object.assign({}, props, {
            datas: proccessDatas
          })
        "
        @changeSort="
          (sort) =>
            $router.assignQuery({
              [`OtherLifeInsuranceSort`]: JSON.stringify(sort)
            })
        "
        :initSort="
          $route.query[`OtherLifeInsuranceSort`]
            ? JSON.parse($route.query[`OtherLifeInsuranceSort`])
            : null
        "
      >
        <template slot="productname" scope="item">
          <div v-if="item.data.isprimarycontract">
            <div class="font-13">
              {{ `${item.data.companyshortname}/${item.data.policynumber}` }}
            </div>
            <div>
              {{
                item.data.productname.split(" ")[1]
                  ? `${item.data.productname.split(" ")[0]}(${
                      item.data.productname.split(" ")[1]
                    })`
                  : item.data.productname
              }}
              <span v-if="item.data.prodid"> ({{ item.data.prodid }}) </span>
            </div>
             <div v-if="item.data.plcvl">
                  <span style="color: #ffa500">
                      保單價值:
                      {{item.data.money == "NTD" ? "" : item.data.money }}
                      {{ Number(item.data.plcvl) | numberFormat3 }}
                 </span>
             </div>
          </div>
          <div v-else>
            <div style="margin-left: 1em; text-indent: -1em">
              <span style="text-shadow: 0px 1px grey" class="text-gray">
                <strong>└</strong>
              </span>
              <span style="font-size: 13px">
                {{ `${item.data.companyshortname}/${item.data.policynumber}` }}
              </span>
            </div>
            <div style="margin-left: 1em">
              {{
                item.data.productname.split(" ")[1]
                  ? `${item.data.productname.split(" ")[0]}(${
                      item.data.productname.split(" ")[1]
                    })`
                  : item.data.productname
              }}
              <span v-if="item.data.prodid"> ({{ item.data.prodid }}) </span>
            </div>
          </div>
        </template>
        <template slot="applicant" scope="item">
          <span v-if="item.data.c111_apc!= ''" @click="routeToCustDetail(item.data.c111_apc , item.data.applicant)" class="link text-underline">
            {{ item.data.applicant | truncate }}
          </span>
          <div  v-else>
             {{ item.data.applicant | truncate }}
          </div>
        </template>
        <template slot="insuredpersonname" scope="item">
          <div
            @click="routeToCustDetail(item.data.insuredpersonid , item.data.insuredpersonname)"
            class="link text-underline"
          >
            {{ item.data.insuredpersonname | truncate }}
          </div>
        </template>
        <template slot="year" scope="item">
          {{ item.data.paymentway == "躉繳" && item.data.producttype == "2" ? "--" : (item.data.year.padLeft(2, "0") + item.data.prd_unit) }}
        </template>
        <template slot="amountofinsurance" scope="item">
          <div
            v-if="item.data.schemename && item.data.quantity"
            class="text-right pre-formatted"
          >
            {{ `計畫${item.data.schemename}：` }}
            {{
              item.data.schemename && item.data.schemename.includes("_1")
                ? ``
                : `日額`
            }}
            {{ `${item.data.quantity}元` }}
          </div>
          <div v-else class="text-right">
            {{ item.data.amountofinsurance }}
          </div>
        </template>
        <template slot="bknm" scope="item">
          <div v-if="item.data.premium">
            {{ item.data.money + ' ' }}{{ item.data.premium }}
          </div>
          <div>{{ item.data.paymentway }}</div>
          <div v-if="item.data.bknm || item.data.card_acnt_no">
            {{ `${item.data.bknm}(${item.data.card_acnt_no})` }}
          </div>
        </template>
        <template slot="bnf" scope="item">
          <div
            v-for="(nameConf, key) in {
              bnf_death_nm: '身故',
              bnf_matag_nm: '滿期',
              bnf_annuity_nm: '年金',
              bnf_birth_nm: '祝壽'
            }"
            :key="key"
          >
            <span
              v-if="item.data[key]"
              :set="(
                names = item.data[key].split(','),
                seqKey = key.replace('_nm', '_ceseq'),
                rateKey = key.replace('_nm', '_rato'),
                seqs = item.data[seqKey] ? item.data[seqKey].split(',') : [],
                rates = item.data[rateKey] ? item.data[rateKey].split(',') : []
              )"
            >
              {{ nameConf }}：
              <span v-for="(name, index) in names" :key="index">
                <truncate-tool :content="name"></truncate-tool>
                {{ (seqs[index]) ? seqs[index] : '' }}
                {{ (rates[index] && rates[index] != '0' && rates[index] != '0.0') ? '(' + Number(rates[index]) + '%)' : '' }}
                {{ names.length - 1 > index ? "、" : "" }}
              </span>
            </span>
          </div>
          <div
            v-if="
              !item.data.bnf_death_nm &&
              !item.data.bnf_matag_nm &&
              !item.data.bnf_annuity_nm &&
              !item.data.bnf_birth_nm
            "
          >
            一一
          </div>
        </template>
        <template slot="action" scope="item">
          <div class="dropdown" v-if="item.data.isMyself">
            <a
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              class="btn btn-icon btn-default btn-sm"
              role="button"
            >
              <i class="icon-more"></i>
            </a>
            <div class="dropdown-menu">
              <a
                role="button"
                class="dropdown-item text-green text-underline"
                @click="toUpdate(item.data)"
                >修改</a
              >
              <!--20250926新增-->
              <a
                role="button"
                class="dropdown-item text-green text-underline"
                @click="toUpdateNew(item.data)"
                >修改(新)</a
              >
              <a
                role="button"
                class="dropdown-item text-green text-underline"
                @click="doDelete(item.data)"
                >刪除</a
              >
              <a
                v-if="item.data.isprimarycontract"
                role="button"
                class="dropdown-item text-green text-underline"
                @click="toAddSubContract(item.data)"
                >新增附約</a
              >

            </div>
          </div>
        </template>
      </data-table>
    </template>
  </data-section>
</template>

<script>
import FamilyMixins from "../common";
import InsuranceMixins from "./Insurance";
import { deleteOtherLifeInsurance, checkOcrSwitch} from "@/service";
import TruncateTool from "./TruncateTool";
import { mvCommonMixin } from '@/desktop/views/mv/mixins/common';

const { moment } = window;
export default {
  mixins: [InsuranceMixins, FamilyMixins, mvCommonMixin],
  components: {
    TruncateTool
  },
  //20250926 新增修改子視窗
  data() {
    return {
      childWindow: null,
      pollingInterval: null,
      messageListener: null,
      //unitExist: false,
      checkClosedInterval: null
    };
  },
  methods: {
    toUpdate(data) {
      const MASTER_CONTRACT = "1";
      const QUERY = {
        contract_id: data.contract_id,
        policyid: data.policyid,
        companyid: data.companyid
      };
      const routeTarget =
        data.contract_type == MASTER_CONTRACT
          ? { name: "add-other-comp-contract", query: QUERY }
          : {
              name: "add-other-comp-sub-contract",
              query: {
                ...QUERY,
                csidno: data.csidno,
                rdstdt: data.issue_date
              }
            };
      this.$router.push(routeTarget);
    },
    async doDelete(data) {
      const productName =
        `${data.policynumber} ${data.productname} ` +
        (data.prodid ? `(${data.prodid})` : "");
      const messageBuilder = data.isprimarycontract
        ? this.buildDeleteMessage
        : this.buildDeleteSubMessage;
      await this.$deleteConfirm(messageBuilder(productName));

      await this.deleteSuccessHandler(
        deleteOtherLifeInsurance({
          contract_type: data.contract_type,
          contract_id: data.contract_id,
          policyid: data.policyid
        })
      );
      this.isLoading = true;
      this.$bus.emit(
        "other-life-insurance.get",
        () => (this.isLoading = false)
      );
    },
    toAddSubContract(data) {
      this.$router.push({
        name: "add-other-comp-sub-contract",
        query: {
          parentContractID: data.contract_id,
          companyid: data.companyid,
          csidno: data.csidno,
          rdstdt: data.issue_date,
          policyid: data.policyid,
          pay_freq: data.pay_freq
        }
      });
    },
    //20250926
    toUpdateNew(data) {
      const familyId = this.getFamilyId();
      const baseUrl = this.getCrmBaseUrl();
      
      const childUrl = `${baseUrl}/api/v1/ocrAuth/loginRedirect`; 
      const base = `${baseUrl}/#/policy-info/PolicyInfo`;
      let innerUrl = `${base}?source=${btoa('parent')}`;
      
      if (familyId) {
        innerUrl = innerUrl + `&familyid=${btoa(familyId)}`;
      }

      if (data.policyid) {
        innerUrl = innerUrl + `&policyid=${btoa(data.policyid)}`
      }

      const outerUrl = `${childUrl}?url=${encodeURIComponent(innerUrl)}`;

      const isApp = window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.openPushPage;

      if (isApp) {
        let categoryObj = {
          title: '手動輸入修改', 
          url: outerUrl,
          page: 'PolicyHealth',
          funcName: 'addPolicy'
        };
        window.webkit.messageHandlers.openPushPage.postMessage(JSON.stringify(categoryObj));
      } else {
        this.openChildWindow(outerUrl, 'manual-input-window');
      }
    },
    
    openChildWindow(url, windowName) {
      // 如果視窗已經開啟且沒被關閉
      if (this.childWindow && !this.childWindow.closed) {
        try {
          // 嘗試聚焦，行動版效果有限
          this.childWindow.focus();
          alert('視窗已開啟，請切換分頁查看');
        } catch (e) {
          console.warn('無法聚焦舊視窗:', e);
        }
        return;
      }

      // 強制停止舊的監控計時器，避免第二次點擊時舊邏輯干擾
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
      if (this.checkClosedInterval) {
        clearInterval(this.checkClosedInterval);
        this.checkClosedInterval = null;
      }
      
      // 判斷是否為行動裝置 (涵蓋 Android, iPhone, iPad)
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      let childWindow = null;;

      if (isMobile) {
        // 行動版 Chrome 不支援指定寬高，帶了參數反而容易被視為彈出式廣告而攔截
        childWindow = window.open(url, windowName);
      } else {
        // 桌機版：保留原有的視窗置中計算與功能設定
        const screenWidth = window.screen.availWidth;
        const screenHeight = window.screen.availHeight;
        const windowWidth = 1200;
        const windowHeight = 800;
        const left = (screenWidth - windowWidth) / 2;
        const top = (screenHeight - windowHeight) / 2;
        const windowFeatures = [
          `width=${windowWidth}`,
          `height=${windowHeight}`,
          `left=${left}`,
          `top=${top}`,
          'scrollbars=yes',
          'resizable=yes'
        ].join(',');

        childWindow = window.open(url, windowName, windowFeatures);
      }
      this.childWindow = childWindow;
      if (!this.childWindow || this.childWindow.closed || typeof this.childWindow.closed === 'undefined') {
        alert('無法開啟子視窗，請檢查瀏覽器彈出視窗設定');
        return;
      }
      
      this.setupPostMessageListener();
      this.monitorChildWindow();
      this.startPollingForMessage();
    },

  setupPostMessageListener() {
    this.messageListener = (event) => {
      const allowedOrigins = [
        'http://localhost:8088',
        'http://localhost:8080', 
        'https://tmycrm.cathaylife.com.tw',
        window.location.origin
      ];
      
      if (!allowedOrigins.includes(event.origin)) {
        return;
      }
      
      if (event.data && typeof event.data === 'object') {
        const data = event.data;
        
        if (data.type === 'MANUAL_INPUT_COMPLETE') {
          this.handleManualInputComplete(data);
        }
        
        if (data.type === 'OPERATION_CANCELLED') {
          this.handleOperationCancelled();
        }
        
        if (data.type === 'WINDOW_CLOSING') {
          this.handleWindowClosing();
        }
      }
    };
    
    window.addEventListener('message', this.messageListener);
  },
  handleManualInputComplete(data) {
      
      this.closeChildWindow();
      const contractId = this.extractFirstContractId(data);
      
      if (contractId) {
        const targetPath = `/mv/familyRelation/policyInfo/edit-list?modify=${contractId}`;

        this.$router.replace(targetPath).then(() => {
          this.$nextTick(() => {
            window.location.reload(); 
          });
        }).catch(err => {
            window.location.reload(); 
        });
      } else {
        console.error('無法取得 contract_id');
        this.isLoading = true;
        this.$bus.emit('other-life-insurance.get', () => {
          this.isLoading = false;
        });
      }
    },
  startPollingForMessage() {
    const startTime = Date.now(); // 記錄開啟視窗的時間點
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
    this.pollingInterval = setInterval(() => {
      const possibleKeys = [
        'childWindowMessage', 
        'policyUploadMessage', 
        'policyInfoMessage',
        'messageFromChild'
      ];
      for (const key of possibleKeys) {
        const message = localStorage.getItem(key);
        if (message) {
          try {
            const data = JSON.parse(message);
            // 如果訊息沒有 timestamp，或是 timestamp 早於開啟時間，就視為舊資料
            if (data.timestamp && data.timestamp < startTime) {
              localStorage.removeItem(key); // 刪除過期資料
              continue; // 跳過，不處理
            }
            this.processMessage(data);
            possibleKeys.forEach(k => localStorage.removeItem(k));
            this.stopPolling();
            return;
          } catch (error) {
            console.error('解析訊息失敗:', error);
          }
        }
      }
      if (!this.childWindow || this.childWindow.closed) {
        this.stopPolling();
      }
    }, 500);
  },

  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
    if (this.messageListener) {
      window.removeEventListener('message', this.messageListener);
      this.messageListener = null;
    }
  },
  processMessage(data) {
    switch (data.type) {
      case 'MANUAL_INPUT_COMPLETE':
        this.handleManualInputComplete(data); 
        break;
      case 'OPERATION_CANCELLED':
        this.closeChildWindow();
        break;
    }
  },
  handleUpdateComplete(data) {
    this.closeChildWindow();
    
    const contractId = this.extractFirstContractId(data);
    
    if (contractId) {
      const targetPath = `/mv/familyRelation/policyInfo/edit-list?modify=${contractId}`;
      this.$router.push(targetPath);
    } else {
      console.error('無法取得 contract_id，重新載入列表');
      this.isLoading = true;
      this.$bus.emit('other-life-insurance.get', () => {
        this.isLoading = false;
      });
    }
  },
  extractFirstContractId(data) {
    try {
      if (data && 
          data.payload && 
          data.payload.apiResponse && 
          data.payload.apiResponse.body && 
          Array.isArray(data.payload.apiResponse.body) && 
          data.payload.apiResponse.body.length > 0) {
        const contractId = data.payload.apiResponse.body[0].contract_id;
        return contractId;
      }
      if (data && 
          data.apiResponse && 
          data.apiResponse.body && 
          Array.isArray(data.apiResponse.body) && 
          data.apiResponse.body.length > 0) {
        return data.apiResponse.body[0].contract_id;
      }
      return null;
    } catch (error) {
      console.error('提取 contract_id 時發生錯誤:', error);
      return null;
    }
  },  
  closeChildWindow() {
    if (this.childWindow && !this.childWindow.closed) {
      this.childWindow.close();
    }
    this.stopPolling();  
    this.childWindow = null;
  },
  handleOperationCancelled() {
    this.closeChildWindow();
  },
  monitorChildWindow() {
      // 如果之前有計時器，先清掉
    if (this.checkClosedInterval) clearInterval(this.checkClosedInterval);

      this.checkClosedInterval = setInterval(() => {
        // 判斷 this.childWindow 是否存在
        if (this.childWindow && this.childWindow.closed) {
          clearInterval(this.checkClosedInterval);
          this.checkClosedInterval = null;
          this.stopPolling();
          // 視窗關閉後，將引用設為 null，下次點擊才不會出錯
          this.childWindow = null; 
        }
      }, 1000);
  },

  getFamilyId() {
    if (this.$store && this.$store.getters && this.$store.getters.UserItems) {
      try {
        const userItems = typeof this.$store.getters.UserItems === 'string' 
          ? JSON.parse(this.$store.getters.UserItems) 
          : this.$store.getters.UserItems;

        const id = userItems.familyid || userItems.csidno;
        if (id) return id;
      } catch (e) {
        console.error('從 store 解析失敗:', e);
      }
    }
    if (localStorage.userItems) {
      try {
        const userItems = JSON.parse(localStorage.userItems);
        const id = userItems.familyid || userItems.csidno;
        if (id) return id;
      } catch (e) {
        console.error('從 localStorage 解析失敗:', e);
      }
    }
    if (localStorage.CustID) {
      return localStorage.CustID;
    }
    return null;
  },
  getCrmBaseUrl() {
    const hostname = window.location.hostname;
    if (process.env.NODE_ENV === 'development') {
      return 'http://localhost:8088';
    }
    if (hostname.includes('tmycrm')) {
      return 'https://tmycrm.cathaylife.com.tw/mid-mxf0-crm-ui';
    }
    if (hostname.includes('smycrm')) {
      return 'https://smycrm.cathaylife.com.tw/mid-mxf0-crm-ui';
    }
    if (hostname.includes('mycrm')) {
      return 'https://mycrm.cathaylife.com.tw/mid-mxf0-crm-ui';
    }
    return 'https://mycrm.cathaylife.com.tw/mid-mxf0-crm-ui';
  },
  /*async checkUnitStatus() {
    try {
      const userInfo = this.$store.state.userInfo || {};
      const userId = userInfo.id || '';
      const divNo = userInfo.divNo || '';

      if (userId && divNo) {
        const result = await checkUnitExist(userId, divNo);
        if (result && result.header && result.header.status == "200" && result.body) {
          this.unitExist = result.body.checkUnitExist;
        }
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  },*/
  reloadWeb(urlStr) {
      this.closeChildWindow();
      // 建立 URL 物件
      const url = new URL(urlStr);

      // 參數在 # (hash) 後面，需要先處理 hash 部分
      const hashParts = url.hash.split('?');
      const params = new URLSearchParams(hashParts[1] || '');
      const modifyValue = params.get('modify');
      console.log('contract_id : ' + modifyValue);
      if (modifyValue) {
        const targetPath = `/mv/familyRelation/policyInfo/edit-list?modify=${modifyValue}`;

        this.$router.replace(targetPath).then(() => {
          this.$nextTick(() => {
            window.location.reload();
          });
        }).catch(err => {
          window.location.reload();
        });
      } else {
        console.error('無法取得 contract_id');
        this.isLoading = true;
        this.$bus.emit('other-life-insurance.get', () => {
          this.isLoading = false;
        });
      }
    }
  },
  computed: {
    modify() {
      return this.$route.query.modify
        ? this.$route.query.modify.split(",")
        : [];
    },
    proccessDatas() {
      const datas = this.datas
        .map((person) =>
          person.majorpolicyinfolist.map((primary) => {
            const primaryData = primary.policyinfolist[0];
            return primary.policyinfolist.map((data) => {
              return Object.assign({}, data, {
                insuredpersonname: person.insuredpersonname,
                insuredpersonid: person.insuredpersonid,
                companyshortname: primary.companyshortname,
                producttype: primary.producttype,
                policynumber: primary.policynumber,
                applicant: primary.applicant,
                c111_apc : primary.c111_apc,
                apcid: primary.apcid,
                card_acnt_no: primary.card_acnt_no,
                hasprimarycontract: primary.hasprimarycontract,
                plcvl: primary.plcvl,
                bknm: primary.bknm,
                trClassName: this.modify.includes(data.contract_id)
                  ? "bg-orange"
                  : data.isprimarycontract
                  ? "bg-white"
                  : "bg-gray",
                isMyself: data.relation == "本人",
                longPremium: data.premium.padLeft(20, "0"),
                sortProductname: this.mergeString(
                  primaryData.compid.padLeft(5, "0"),
                  primary.policynumber,
                  primary.policyid
                ),
                sortApplicant: this.mergeString(
                  primaryData.applicant,
                  primary.policyid
                ),
                sortInsuredpersonname: this.mergeString(
                  person.insuredpersonname,
                  primary.policyid
                ),
                sortInsuranceADDate: this.mergeString(
                  moment(primaryData.insurancedate).getADDate(),
                  primary.policyid
                ),
                sortBknm: this.mergeString(
                  // 沒有數字可以被放一起
                  !primaryData.premium ? "" : "_",
                  primaryData.money,
                  // 左邊補0讓文字可以被排序
                  primaryData.premium.padLeft(20, "0"),
                  primary.policyid
                )
              });
            });
          })
        )
        .flat()
        .flat();

      const { _ } = window;
      const MASTER_CONTRACT = "1";
      const relationOrder = _.invert(["本人", "配偶", "子女"]);

      const findRelationInDatas = (relation) =>
        _.filter(datas, {
          contract_type: MASTER_CONTRACT,
          relation
        });
      // 本人主約
      const myselfContracts = findRelationInDatas("本人");
      // 配偶主約
      let spouseContracts = findRelationInDatas("配偶");
      // 子女主約
      let sonContracts = findRelationInDatas("子女");

      // 附約
      let subContracts = _.reject(datas, {
        contract_type: MASTER_CONTRACT
      });

      // 取出屬於這張單的內容，"並從原資料中移除"
      const pickBelongContract = (policyid) => (datas) =>
        _.remove(datas, { policyid: policyid });
      return myselfContracts
        .reduce((result, myselfContract) => {
          const pickBelongThisContract = pickBelongContract(
            myselfContract.policyid
          );
          const thisPartContracts = []
              // 這張單的本人主約
              .concat(myselfContract)
              // 屬於這張單的附約
              .concat(
                _.map(
                  _.groupBy(
                    pickBelongThisContract(subContracts),
                    "contract_id"
                  ),
                  (datas) => _.orderBy(datas, (x) => relationOrder[x.relation])
                ).flat()
              )
              // 屬於這張單的配偶主約
              .concat(pickBelongThisContract(spouseContracts))
              // 屬於這張單的子女主約
              .concat(pickBelongThisContract(sonContracts))
              .map(x => ({
                ...x,
                sortInsuredpersonname: this.mergeString(
                  myselfContract.insuredpersonname,
                  myselfContract.policyid
                ),
                sortBknm: this.mergeString(
                  // 沒有數字可以被放一起
                  !myselfContract.premium ? "" : "_",
                  myselfContract.money,
                  // 左邊補0讓文字可以被排序
                  myselfContract.premium.padLeft(20, "0"),
                  myselfContract.policyid
                ),
                sortInsuranceADDate: this.mergeString(
                  moment(myselfContract.insurancedate).getADDate(),
                  myselfContract.policyid
                )
              }))
          return result.concat(thisPartContracts)
        }, [])
        .concat(spouseContracts)
        .concat(sonContracts)
        .concat(subContracts);
    }
  },
  mounted() {
    // this.checkUnitStatus(); 

    // 判斷是否是app
    const isApp = !!(window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.openPushPage);
        
    if(isApp) {
      window.reloadWeb = (urlStr) => {
        try {
          if (this && typeof this.reloadWeb === 'function') {
            this.reloadWeb(urlStr);
            return "success";
          }
          return "instance_not_found";
        } catch(e) {
          console.error(e);
          return "error"; 
        }
      };
    }
  },
  beforeDestroy() {
    if (window.reloadWeb) {
      window.reloadWeb = null;
    }
  }
};
</script>